export default function AuthPrimaryButton({ children, disabled, className = '', type = 'button', ...props }) {
  const enabledClass = 'bg-primary-purple-01 text-white';
  const disabledClass = 'bg-[rgba(139,104,221,0.3)] text-gray03 pointer-events-none';

  return (
    <button
      type={type}
      disabled={disabled}
      className={`flex h-[53px] w-full items-center justify-center rounded-[10px] border-0 font-['Pretendard'] text-[16px] font-bold outline-none transition-colors ${
        disabled ? disabledClass : enabledClass
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
